module.exports = __webpack_public_path__ + "static/media/WEF-norming-Intro-lower.b8719bc9.mp3";